import { axiosWithAuth } from "../../helpers";

export const businessInfoService = {
	sendGeoLocation,
};

const API_URL = process.env.REACT_APP_API_URL;
function sendGeoLocation(model) {
	const options = {
		method: "POST",
		data: model,
		url: `${API_URL}/api/applications/setAddressCoordinate`,
	};
	return axiosWithAuth(options);
}
